// axios即将弃用，请使用request.ts
import axios from '@/utils/axios';
const prefix = 'ldhhapi/marketing/activity/mk-activity-community/'; //前缀
const couponPrefix = 'ldhhapi/marketing/coupon/mk-coupon/'; //前缀
const loginApi = {
  login: {
    // 社群落地页
    getSigninQuery: (data?: any) =>
      axios.post(prefix + 'getActivityCommunityById', data), //查询活动详情
    sendMessageCode: (data?: any) =>
      axios.post(prefix + 'sendMessageCode', data), //发送验证码
    sendPromotionCoupon: (data?: any) =>
      axios.post(prefix + 'sendPromotionCoupon', data), //领取推广优惠券
    getUserCouponAndPageByActId: (data?: any) =>
      axios.post(couponPrefix + 'getUserCouponAndPageByActId', data), //券列表

    //员工引流
    getActivityCommunityById: (data?: any) =>
      axios.post(
        'ldhhapi/marketing/mkActivityDrainage/getActivityCommunityById',
        data
      ), //查询活动详情
    sendMessageCodeStaff: (data?: any) =>
      axios.post('ldhhapi/marketing/mkActivityDrainage/sendMessageCode', data), //发送验证码

    sendPromotionCouponStaff: (data?: any) =>
      axios.post(
        'ldhhapi/marketing/mkActivityDrainage/sendPromotionCoupon',
        data
      ), //领取推广优惠券
    getUserCouponAndPageByActIdStaff: (data?: any) =>
      axios.post(
        'ldhhapi/marketing/coupon/mk-coupon/getUserCouponAndPageByActId',
        data
      ), //券列表
  },
};
export default loginApi;
